// Lightweight relative time helper without external deps
// Returns strings like: "just now", "5m ago", "2h ago", "Yesterday", "3d ago", "Sep 12", "Sep 12 2024" (if different year)
export function formatRelativeTime(dateInput) {
  if (!dateInput) return 'Never';
  const date = (dateInput instanceof Date) ? dateInput : new Date(dateInput);
  if (isNaN(date.getTime())) return 'Never';

  const now = new Date();
  const diffMs = now - date;
  if (diffMs < 0) return 'in the future';

  const sec = Math.floor(diffMs / 1000);
  if (sec < 10) return 'just now';
  if (sec < 60) return sec + 's ago';

  const min = Math.floor(sec / 60);
  if (min < 60) return min + 'm ago';

  const hrs = Math.floor(min / 60);
  if (hrs < 24) return hrs + 'h ago';

  const days = Math.floor(hrs / 24);
  if (days === 1) return 'Yesterday';
  if (days < 7) return days + 'd ago';
  if (days < 30) {
    const weeks = Math.floor(days / 7);
    return weeks + 'w ago';
  }
  // For older than a month, show month/day, include year if different
  const optionsSameYear = { month: 'short', day: 'numeric' };
  const optionsWithYear = { month: 'short', day: 'numeric', year: 'numeric' };
  if (date.getFullYear() === now.getFullYear()) {
    return date.toLocaleDateString(undefined, optionsSameYear);
  }
  return date.toLocaleDateString(undefined, optionsWithYear);
}
